export const CDN_BASE_URL = 'https://cdn.whitewhale.help';

export const normalizeCdnUrl = (value) => {
    if (!value || typeof value !== 'string') return value;

    try {
        const source = value.trim().startsWith('//') ? `https:${value.trim()}` : value.trim();
        const url = new URL(source);
        if (url.hostname === 'animix.lol' || url.hostname.endsWith('.animix.lol')) {
            url.hostname = `${url.hostname.slice(0, -'animix.lol'.length)}whitewhale.help`;
            url.protocol = 'https:';
        }
        return url.toString();
    } catch (error) {
        return value;
    }
};

export const buildCdnUrl = (baseUrl, path) => {
    const normalizedBaseUrl = normalizeCdnUrl(baseUrl);
    const normalizedPath = String(path || '').replace(/^\/+/, '');

    try {
        return new URL(normalizedPath, `${normalizedBaseUrl.replace(/\/+$/, '')}/`).toString();
    } catch (error) {
        return `${String(normalizedBaseUrl || '').replace(/\/+$/, '')}/${normalizedPath}`;
    }
};
